/**
 * @Description CFO驾驶舱数据接口
 */
import request from '@/utils/request'

/**
 * 统一解析 CFO 驾驶舱接口响应
 * 兼容：直接业务对象 / { code, data } / 数组
 */
export function unwrapDashboardResponse(res) {
  if (res == null) return res
  if (Array.isArray(res)) return res
  const payload = res.data
  const hasBizPayload = payload != null && (
    Array.isArray(payload) ||
    payload.nodes ||
    payload.links ||
    payload.target_gm != null ||
    payload.trend_points ||
    payload.kpi_name
  )
  if (hasBizPayload && (res.code === 200 || res.code === 0 || res.code === '200' || res.code === undefined)) {
    return payload
  }
  if (res.nodes || res.links || res.target_gm != null || res.trend_points || res.kpi_name) {
    return res
  }
  return res
}

/**
 * 获取企业核心经营指标带（8列KPI卡片）
 * @returns {Promise<Array<{kpi_name: string, current_val: number, target_val: number|null, severity: string}>>}
 */
export function fetchKpiCards() {
  return request({
    url: '/cfo-api/api/dashboard/kpi-cards',
    method: 'GET'
  })
}

/**
 * 获取E2E损益结构穿透Sankey图数据
 * @returns {Promise<{nodes: Array<{id: string, label: string, amount: number}>, links: Array<{source: string, target: string, value: number}>}>}
 */
export function fetchSankey() {
  return request({
    url: '/cfo-api/api/dashboard/sankey',
    method: 'GET'
  })
}

/**
 * 获取毛利率经营关差动作（瀑布图+明细表）
 * @returns {Promise<{target_gm: number, actual_gm: number, bars: Array, detail: Array}>}
 */
export function fetchGapClosing() {
  return request({
    url: '/cfo-api/api/dashboard/gap-closing',
    method: 'GET'
  })
}

/**
 * 获取T+3滚动预测与情景模拟
 * @returns {Promise<{trend_points: Array, sensitivity_bars: Array, scenarios: Array}>}
 */
export function fetchScenarioSimulation() {
  return request({
    url: '/cfo-api/api/dashboard/scenario-simulation',
    method: 'GET'
  })
}
